import Vue from 'vue'
import axios from 'axios'

const initState = {
  integrations: [],
  integrationsObject: {}
}

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {
    SET_INTEGRATIONS(state, integrations) {
      state.integrations = integrations
      const object = {}
      integrations.forEach((integration) => {
        object[`integration-${integration.id}`] = integration
      })
      state.integrationsObject = object
    },
    UPDATE_INTEGRATION(state, singleIntegration) {
      const integrations = state.integrations
      const integrationsObject = state.integrationsObject
      if (!integrationsObject[`integration-${singleIntegration.id}`]) {
        integrations.push(singleIntegration)
      } else {
        let indexFound = -1
        integrations.every((item, index) => {
          if (item.id === singleIntegration.id) {
            indexFound = index
            return false
          }
          return true
        })
        if (indexFound >= 0) {
          integrations.splice(indexFound, 1, singleIntegration)
        }
      }
      integrationsObject[`integration-${singleIntegration.id}`] = singleIntegration
      state.integrations = integrations
      state.integrationsObject = integrationsObject
    },
    DELETE_INTEGRATION(state, singleIntegrationId) {
      const integrations = state.integrations
      const integrationsObject = state.integrationsObject
      if (integrationsObject[`integration-${singleIntegrationId}`]) {
        delete integrationsObject[`integration-${singleIntegrationId}`]
        let indexFound = -1
        integrations.every((item, index) => {
          if (item.id === singleIntegrationId) {
            indexFound = index
            return false
          }
          return true
        })
        if (indexFound >= 0) {
          integrations.splice(indexFound, 1)
        }
      }
      state.integrations = integrations
      state.integrationsObject = integrationsObject
    }
  },
  actions: {
    getAllIntegrations({ commit }, landingId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/integrations/all`)
          .then((res) => {
            commit('SET_INTEGRATIONS', res.data.integrations)
            resolve(res.data.integrations)
          })
          .catch((error) => reject(error))
      })
    },
    checkName({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landing_id}/integrations/check-name`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updateName({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${params.landing_id}/integrations/${params.id}/name`, params)
          .then((res) => {
            commit('UPDATE_INTEGRATION', res.data.integration)
            resolve(res.data.integration)
          })
          .catch((error) => reject(error))
      })
    },
    createIntegration({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landing_id}/integrations`, params)
          .then((res) => resolve(res.data.integration))
          .catch((error) => reject(error))
      })
    },
    updateIntegration({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${params.landing_id}/integrations/${params.id}`, params)
          .then((res) => {
            commit('UPDATE_INTEGRATION', res.data.integration)
            resolve(res.data.integration)
          })
          .catch((error) => reject(error))
      })
    },
    toggleIntegration({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${params.landing_id}/integrations/${params.id}/toggle`, params)
          .then((res) => {
            commit('UPDATE_INTEGRATION', res.data.integration)
            resolve(res.data.integration)
          })
          .catch((error) => reject(error))
      })
    },
    destroyIntegration({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${params.landing_id}/integrations/${params.id}`)
          .then(() => {
            commit('DELETE_INTEGRATION', params.id)
            resolve(true)
          })
          .catch((error) => reject(error))
      })
    },
    callGetApi({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landingId}/integrations/${params.integrationId}/call-get-api`, params)
          .then((res) => resolve(res.data.response))
          .catch((error) => reject(error))
      })
    },
    checkOAuthAccountRequest({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/oauth-accounts/verify`, params)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    selectOptions({ commit }, queries) {
      return new Promise((resolve, reject) => {
        axios
          .get(`integrations/user/select-options`, { params: queries })
          .then((res) => {
            resolve(res.data.data.options)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
  getters: {
    integrations(state) { return state.integrations }
  }
}